import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { AccessControlModal } from './AccessControl';
import ExitWithoutSavingModal from './AccessControl/components/ExitWithoutSavingModal';
import GoalPreferencesContainer from './GoalPreferencesContainer';
import ConfirmationModal from './components/ConfirmationModal';
import Footer from './components/Footer';
import Header from './components/Header';
import GoalPreferencesProvider from './context/GoalPreferencesProvider';

const GoalPreferences = () => (
  <>
    <GoalPreferencesProvider>
      {!checkNewNavEnabled() && <Header />}
      <GoalPreferencesContainer />
      <Footer />
      <ConfirmationModal />
      <ExitWithoutSavingModal />
    </GoalPreferencesProvider>
    <AccessControlModal />
  </>
);

export default GoalPreferences;
